/* Clinical documents: sick sheets, referral letters and uploads (consultation plan §7.4). */

.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
}

.heading {
  margin: 0;
  font: var(--t-heading);
}

.subheading {
  margin: 0;
  font: var(--t-body-strong);
}

.help {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-2) var(--space-3);
  padding: var(--space-3) 0;
  border-top: 1px solid var(--rule);
}

.itemMain {
  display: flex;
  flex: 1 1 16rem;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.itemTitle {
  font: var(--t-body-strong);
  overflow-wrap: anywhere;
}

.meta {
  color: var(--graphite);
  font: var(--t-small);
}

.mono {
  font-family: var(--font-id);
  font-variant-numeric: tabular-nums;
}

.itemActions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.fields {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.row > * {
  flex: 1 1 10rem;
}

.summary {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-3);
  border: 1px solid var(--rule);
  border-radius: var(--radius-control);
}

.summaryLine {
  margin: 0;
  font: var(--t-small);
}

.printer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-3);
}

.preview {
  max-width: 100%;
  overflow-x: auto;
}

.printHeading {
  margin: 4mm 0 1mm;
  font-size: 1em;
  font-weight: 700;
}

.printText {
  margin: 0 0 2mm;
}

.viewer {
  display: block;
  width: 100%;
  height: 60vh;
  border: 1px solid var(--rule);
}

.viewerImage {
  display: block;
  max-width: 100%;
  max-height: 60vh;
  margin: 0 auto;
  object-fit: contain;
}
